module.exports = __webpack_public_path__ + "Server-NeedsUpgrade.TentacleActive.8cea8dbdf30a07ce754b28e710d37ad2.hashedasset.svg";